package com.dotdrives.web.ui

import com.dotdrives.design.DotButtonVariant
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.p
import web.cssom.ClassName

data class DotAction(
    val text: String,
    val onClick: () -> Unit,
)

external interface DotEmptyStateProps : Props {
    var emoji: String
    var title: String
    var body: String
    var primaryAction: DotAction?
    var secondaryAction: DotAction?
    var className: String?
}

val DotEmptyState = FC<DotEmptyStateProps> { props ->
    div {
        className = ClassName(listOfNotNull("dot-empty-state", props.className).joinToString(" "))
        div {
            className = ClassName("dot-empty-emoji")
            ariaHidden = true
            +props.emoji
        }
        h2 {
            className = ClassName("dot-heading dot-h2 dot-empty-title")
            +props.title
        }
        p {
            className = ClassName("dot-body dot-empty-body")
            +props.body
        }
        if (props.primaryAction != null || props.secondaryAction != null) {
            div {
                className = ClassName("dot-empty-actions")
                props.primaryAction?.let { action ->
                    DotButton {
                        text = action.text
                        onClick = action.onClick
                        className = "dot-full-width"
                    }
                }
                props.secondaryAction?.let { action ->
                    DotButton {
                        text = action.text
                        onClick = action.onClick
                        variant = DotButtonVariant.Secondary
                        className = "dot-full-width"
                    }
                }
            }
        }
    }
}
